import { z } from 'zod';
import type { User } from './Owner';

export const selectionSchema = z.object({
  id: z.number(),
  type: z.string(),
  sort: z.string(),
  selection: z.string(),
  subselection: z.string(),
  selectionValue: z.string(),
  selectionMeta1: z.string(),
  metaData: z.string(),
  actionData: z.string(),
});

export const standardSelectionSchema = z.object({
  id: z.number(),
  name: z.string(),
  displayName: z.string(),
});

export type Selection = z.infer<typeof selectionSchema>;
export type StandardSelection = Required<z.infer<typeof standardSelectionSchema>>;

export type ActivitiesSelections = {
  methods: StandardSelection[];
  purposes: StandardSelection[];
  reminderTypes: StandardSelection[];
  types: StandardSelection[];
}

export type SelectionApiResponse = {
  data: {
    selections: {
      activities: ActivitiesSelections;
    },
    users: User[];
    salesScopedUsers: User[];
  }
}
